import React from 'react'

const IconClose = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6890_7496)">
                <path d="M12.1821 5.81786C11.7429 5.37857 11.0304 5.37857 10.5911 5.81786L9 7.40893L7.40893 5.81786C6.96964 5.37857 6.25714 5.37857 5.81786 5.81786C5.37857 6.25714 5.37857 6.96964 5.81786 7.40893L7.40893 9L5.81786 10.5911C5.37857 11.0304 5.37857 11.7429 5.81786 12.1821C6.25714 12.6214 6.96964 12.6214 7.40893 12.1821L9 10.5911L10.5911 12.1821C10.8107 12.4018 11.1 12.5089 11.3893 12.5089C11.6786 12.5089 11.9625 12.3964 12.1875 12.1821C12.6268 11.7429 12.6268 11.0304 12.1875 10.5911L10.5911 9L12.1821 7.40893C12.6214 6.96964 12.6214 6.25714 12.1821 5.81786Z" fill="#CB002B" />
                <path d="M9 0C4.03929 0 0 4.03929 0 9C0 13.9607 4.03929 18 9 18C13.9607 18 18 13.9607 18 9C18 4.03929 13.9607 0 9 0ZM9 15.75C5.27679 15.75 2.25 12.7232 2.25 9C2.25 5.27679 5.27679 2.25 9 2.25C12.7232 2.25 15.75 5.27679 15.75 9C15.75 12.7232 12.7232 15.75 9 15.75Z" fill="#CB002B" />
            </g>
            <defs>
                <clipPath id="clip0_6890_7496">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconClose